import { FC, PropsWithChildren } from 'react';

import { Box, Stack } from '@mui/material';

import styles from '@components/table/components/components.module.scss';

export const ActionCell: FC<PropsWithChildren> = ({ children }) => (
    <Stack
        direction="row"
        sx={{
            justifyContent: 'flex-end',
        }}
    >
        <Box sx={{ overflow: 'hidden' }}>
            <div className={styles.action} data-testid="test-id-action-cell">
                <Box>{children}</Box>
            </div>
        </Box>
    </Stack>
);
